// Preço "de", exibido riscado acima do preço real. Fonte única para os cards
// (PlanShowcase.vue) e para a linha de preço da tabela comparativa
// (Subscription/pricing-comparison.js), que precisam concordar.
//
// O valor vem da oferta do billing (`originalValue`, mapeado em `originalFee`), e não
// mais de uma tabela fixa aqui: cada tabela de preço tem o seu riscado. A campanha
// (Black November) risca o preço normal; a tabela comum risca o de marketing.

/**
 * Preço riscado do plano, ou `null` quando não há um — inclusive quando o valor
 * anterior não é maior que o atual, caso em que riscar não diria nada.
 */
export function getPlanOriginalPrice (plan) {
  if (!plan) return null

  const originalPrice = plan.originalFee

  if (originalPrice === undefined || originalPrice === null) return null
  if (originalPrice <= plan.monthlyFee) return null
  return originalPrice
}

export default { getPlanOriginalPrice }



// WEBPACK FOOTER //
// ./src/utils/plan-original-price.js